import React, {useState} from 'react'

import DisplayDayModal from './DayDisplayModal'
import SummaryPlanDisplay from './SummaryPlanDisplay'

import {
    CardHeader,
    Row,
    Col,
    CardFooter,
    Progress,
}from "reactstrap";

import Aer1 from '../../assets/img/aer1.png'
import Tempo from '../../assets/img/tempo.png'
import Aer2 from '../../assets/img/aer2.png'
import Rest from '../../assets/img/rest.png'
import Swim from '../../assets/img/swim.png'
import Base from '../../assets/img/base.png'
import Interval from '../../assets/img/intervalcon.png'
import Ride from '../../assets/img/ride.png'
import Summary from '../../assets/img/logo3.png'

import './cardhover.css'
var moment = require('moment')
function WeekPlanner({week,measurementSystem}){
    //console.log(week)
    
    var summaryList = [[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0]]


    const changeSummary = (day,list) =>{
        summaryList[day] = list
        //console.log(summaryList)
        
    } 
    
    if (week.monday === undefined || week.monday === null){
        return (<div>wait</div>)
    }
    
    const pickImage = (type) =>{
        var activityIcon = Rest
        if (type === "Interval 1-1"){
            activityIcon = Interval
        }
        if (type === "Interval 1-2"){
            activityIcon = Interval
        }
        if (type === "Interval 1-3"){
            activityIcon = Interval
        }
        if (type === "Interval 2-1"){
            activityIcon = Interval
        }
        if (type === "Interval 3-1"){
            activityIcon = Interval
        }
        if (type === "Aerobic 1"){
            activityIcon = Aer1
        }
        if (type === "Aerobic 2"){
            activityIcon = Aer2
        }
        if (type === "Threshold"){
            activityIcon = Tempo
        }
        if (type === "Base/Long Run"){
            activityIcon = Base
        }
        if (type === "Ride"){
            activityIcon = Ride
        }
        if (type === "Swim"){
            activityIcon = Swim
        }
        return activityIcon
    }
    return(
        <>
        <p style={{color:'rgb(100,170,100)',fontSize:'25px'}}>{moment(week.date).format("MM-YYYY")}</p>
        <thead style={{color:'rgb(100,240,240)'}}>
                      <tr>
                         <th>
                             Monday
                         </th>
                         <th>
                             Tuesday
                         </th>
                         <th>
                             Wednesday
                         </th>
                         <th>
                             Thursday
                         </th>
                         <th>
                             Friday
                         </th>
                         <th>
                             Saturday
                         </th>
                         <th>
                             Sunday
                         </th>
                         <th>
                             Summary
                         </th>
                      </tr>
                    </thead>
            <tbody style={{backgroundColor:'#222222',padding:'-15px'}}>
            <td className='cardWeek' style={{backgroundColor:'#222222',padding:'-15px'}}>
                    <div className="card-chart" style={{backgroundColor: '#222222',color: '#FFFFFF',padding:'-5px',margin:'-5px'}}>
                        <CardHeader>
                        <h5 className="card-category text-warning">{week.date ? moment(week.date).format("DD") : ""}</h5>
                        <Row>
                            <Col xs={12} md={1}>
                            
                            </Col>
                            <Col xs={12} md={9}>
                                <DisplayDayModal changeSummary={changeSummary} dayNo={0} data={week.monday} day='Monday' subType={pickImage(week.monday.subType)}/>
    
                            </Col>
                            
                            <Col xs={12} md={1}>
                            
                            </Col>
                        </Row>
                        
                        </CardHeader>
                        <CardFooter>
                        <div className="stats">
                            <i className="now-ui-icons media-2_sound-wave" style={{color:'rgb(100,100,255)'}}/> <span>-</span>
                        </div>
                        </CardFooter>
                        
                    </div>
                      
                </td>
                <td className='cardWeek' style={{backgroundColor:'rgb(30,30,30)',padding:'-15px'}}>
                    <div className="card-chart" style={{backgroundColor: 'rgb(30,30,30)',color: '#FFFFFF',padding:'-5px',margin:'-5px'}}>
                        <CardHeader>
                        <h5 className="card-category text-warning">{week.date ? moment(week.date).add(1,'day').format("DD") : ""}</h5>
                        <Row>
                            <Col xs={12} md={1}>
                            
                            </Col>
                            <Col xs={12} md={9}>
                                <DisplayDayModal changeSummary={changeSummary} dayNo={1} data={week.tuesday} day='Tuesday'subType={pickImage(week.tuesday.subType)}/>
                            </Col>
                            
                            <Col xs={12} md={1}>
                            
                            </Col>
                        </Row>
                        
                        </CardHeader>
                        <CardFooter>
                        <div className="stats">
                            <i className="now-ui-icons media-2_sound-wave" style={{color:'rgb(100,100,255)'}}/> <span>-</span>
                            
                        </div>
                        </CardFooter>
                        
                    </div>
                      
                </td>
                <td className='cardWeek' style={{backgroundColor:'#222222',padding:'-15px'}}>
                    <div className="card-chart" style={{backgroundColor: '#222222',color: '#FFFFFF',padding:'-5px',margin:'-5px'}}>
                        <CardHeader>
                        <h5 className="card-category text-warning">{week.date ? moment(week.date).add(2,'day').format("DD") : ""}</h5>
                        <Row>
                            <Col xs={12} md={1}>
                            
                            </Col>
                            <Col xs={12} md={9}>
                                <DisplayDayModal changeSummary={changeSummary} dayNo={2} data={week.wednesday} day='Wednesday' subType={pickImage(week.wednesday.subType)}/>
                            </Col>
                            
                            <Col xs={12} md={1}>
                            
                            </Col>
                        </Row>
                        
                        </CardHeader>
                        <CardFooter>
                        <div className="stats">
                            <i className="now-ui-icons media-2_sound-wave" style={{color:'rgb(100,100,255)'}}/> <span>-</span>
                        </div>
                        </CardFooter>
                        
                    </div>
                      
                </td>
                <td className='cardWeek' style={{backgroundColor:'rgb(30,30,30)',padding:'-15px'}}>
                    <div className="card-chart" style={{backgroundColor: 'rgb(30,30,30)',color: '#FFFFFF',padding:'-5px',margin:'-5px'}}>
                        <CardHeader>
                        <h5 className="card-category text-warning">{week.date ? moment(week.date).add(3,'day').format("DD") : ""}</h5>
                        <Row>
                            <Col xs={12} md={1}>
                            
                            </Col>
                            <Col xs={12} md={9}>
                                <DisplayDayModal changeSummary={changeSummary} dayNo={3} data={week.thursday} day='Thursday' subType={pickImage(week.thursday.subType)}/>
                            </Col>
                            
                            <Col xs={12} md={1}>
                            
                            </Col>
                        </Row>
                        
                        </CardHeader>
                        <CardFooter>
                        <div className="stats">
                            <i className="now-ui-icons media-2_sound-wave" style={{color:'rgb(100,100,305)'}}/> <span>-</span>
                        </div>
                        </CardFooter>
                        
                    </div>
                      
                </td>
                <td className='cardWeek' style={{backgroundColor:'#222222',padding:'-15px'}}>
                    <div className="card-chart" style={{backgroundColor: '#222222',color: '#FFFFFF',padding:'-5px',margin:'-5px'}}>
                        <CardHeader>
                        <h5 className="card-category text-warning">{week.date ? moment(week.date).add(4,'day').format("DD") : ""}</h5>
                        <Row>
                            <Col xs={12} md={1}>
                            
                            </Col>
                            <Col xs={12} md={9}>
                                <DisplayDayModal changeSummary={changeSummary} dayNo={4} data={week.friday}  day='Friday' subType={pickImage(week.friday.subType)}/>
                            </Col>
                            
                            <Col xs={12} md={1}>
                            
                            </Col>
                        </Row>
                        
                        </CardHeader>
                        <CardFooter>
                        <div className="stats">
                            <i className="now-ui-icons media-2_sound-wave" style={{color:'rgb(100,100,255)'}}/> <span>-</span>
                        </div>
                        </CardFooter>
                        
                    </div>
                      
                </td>
                <td className='cardWeek' style={{backgroundColor:'rgb(30,30,30)',padding:'-15px'}}>
                    <div className="card-chart" style={{backgroundColor: 'rgb(30,30,30)',color: '#FFFFFF',padding:'-5px',margin:'-5px'}}>
                        <CardHeader>
                        <h5 className="card-category text-warning">{week.date ? moment(week.date).add(5,'day').format("DD") : ""}</h5>
                        <Row>
                            <Col xs={12} md={1}>
                            
                            </Col>
                            <Col xs={12} md={9}>
                                <DisplayDayModal changeSummary={changeSummary} dayNo={5} data={week.saturday} day='Saturday' subType={pickImage(week.saturday.subType)}/>
                            </Col>
                            
                            <Col xs={12} md={1}>
                            
                            </Col>
                        </Row>
                        
                        </CardHeader>
                        <CardFooter>
                        <div className="stats">
                            <i className="now-ui-icons media-2_sound-wave" style={{color:'rgb(100,100,255)'}}/> <span>-</span>
                        </div>
                        </CardFooter>
                        
                    </div>
                      
                </td>
                <td className='cardWeek' style={{backgroundColor:'#222222',padding:'-15px'}}>
                    <div className="card-chart" style={{backgroundColor: '#222222',color: '#FFFFFF',padding:'-5px',margin:'-5px'}}>
                        <CardHeader>
                        <h5 className="card-category text-warning">{week.date ? moment(week.date).add(6,'day').format("DD") : ""}</h5>
                        <Row>
                            <Col xs={12} md={1}>
                            
                            </Col>
                            <Col xs={12} md={9}>
                                <DisplayDayModal changeSummary={changeSummary} dayNo={6} data={week.sunday} day='Sunday' subType={pickImage(week.sunday.subType)}/>
                            </Col>
                            
                            <Col xs={12} md={1}>
                            
                            </Col>
                        </Row>
                        
                        </CardHeader>
                        <CardFooter>
                        <div className="stats">
                            <i className="now-ui-icons media-2_sound-wave" style={{color:'rgb(100,100,255)'}}/> <span>-</span>
                        </div>
                        </CardFooter>
                        
                    </div>
                      
                </td>
                <td className='cardWeek' style={{backgroundColor:'rgb(100,100,110)',padding:'-15px'}}>
                    <div className="card-chart" style={{backgroundColor: 'rgb(100,100,110)',color: '#FFFFFF',padding:'-5px',margin:'-5px'}}>
                        <CardHeader>
                        <h5 className="card-category text-warning">--</h5>
                        <Row>
                            <Col xs={12} md={1}>
                            
                            </Col>
                            <Col xs={12} md={9}>
                                <SummaryPlanDisplay Summary={Summary} summaryList={summaryList} week={week} data={week.sunday} day='Sunday' subType={pickImage(week.sunday.subType)}/>
                            </Col>
                            
                            <Col xs={12} md={1}>
                            
                            </Col>
                        </Row>
                        
                        </CardHeader>
                        <CardFooter>
                        <div className="stats">
                            <i className="now-ui-icons media-2_sound-wave" style={{color:'rgb(100,100,255)'}}/> <span>-</span>
                        </div>
                        </CardFooter>
                        
                    </div>
                      
                </td>
                
            
                
            </tbody>
            
                
            
                
            
            
            
            
        </>
    )
}
    
 

export default WeekPlanner